export default "__VITE_ASSET__Dd6WI7ke__"